import { createSlice } from '@reduxjs/toolkit';
import {
  _addCompletedStudent,
  _removeCompletedStudent,
  _setSidebarSelectedStudent,
} from './ssaSidenavBarStudentDetailsAction';

const initialState = { sideBarSelectedStudent: [], completedStudents: [] };

export const ssaSidenavBarStudentDetailsSlice = createSlice({
  name: 'delta/SSASidenavBarStudentDetailsSlice',
  initialState,
  reducers: {
    addCompletedStudent: _addCompletedStudent,
    removeCompletedStudent: _removeCompletedStudent,
    resetSidebarSelectedStudent: () => initialState,
    setSidebarSelectedStudent: _setSidebarSelectedStudent,
  },
});

export const {
  addCompletedStudent,
  removeCompletedStudent,
  setSidebarSelectedStudent,
  resetSidebarSelectedStudent,
} = ssaSidenavBarStudentDetailsSlice.actions;

export default ssaSidenavBarStudentDetailsSlice.reducer;
